<template>
    <p
        :class="cssClass"
        :id="id"
    >
        {{ value }}
    </p>
</template>

<script>
export default {

    name: 'InputStatic',

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        isBulma: {
            type: Boolean,
            default: true,
        },
        bootstrap: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        cssClass() {
            let classes = [];
            if(this.bootstrap) { classes.push('form-control-static'); }
            if(this.isBulma) { classes.push('input is-static')}
            return classes.join(' ');
        },
    },

}
</script>
